import { render, staticRenderFns } from "./usdtExtra.vue?vue&type=template&id=26f7b8ea"
import script from "./usdtExtra.vue?vue&type=script&lang=ts"
export * from "./usdtExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports